export const GAM_NOT_CONNECTED_URL =
  'https://knowledge-base.yieldbird.com/yieldbird-platform/gam-api-connection' as const
